"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _vuex = require("vuex");
var _booking = require("@/api/bookSpace/booking");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _utils = require("@/utils");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "",
  components: {
    dragDialog: _DragDialog.default,
    Pagination: _Pagination.default
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    disabledType: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      filterForm: {
        vesselCode: '',
        serviceLineCode: '',
        vesselName: '',
        voyageNo: '',
        voyageLeg: '',
        saillingDate: '',
        pol: '',
        pod: '',
        currentPage: 1,
        pageSize: 10,
        dataTime: []
      },
      rules: {
        pol: [{
          required: true,
          message: this.$t('booking.bookingJapan.polWarning'),
          trigger: 'change'
        }],
        pod: [{
          required: true,
          message: this.$t('booking.bookingJapan.podWarning'),
          trigger: 'change'
        }]
      },
      total: 0,
      tableData: []
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    changeVessel: function changeVessel(row, val) {
      this.filterForm.vesselName = val.vesselName;
    },
    vesselChange: function vesselChange(value, selectedRows) {
      this.filterForm.vesselName = selectedRows.vesselName;
    },
    indexMethod: function indexMethod(index) {
      return (this.filterForm.currentPage - 1) * this.filterForm.pageSize + index + 1;
    },
    opened: function opened() {
      // this.handleSearch()
      console.log('opened');
    },
    handleReset: function handleReset() {
      this.filterForm = {
        vesselCode: '',
        serviceLineCode: '',
        vesselNameCn: '',
        voyageNo: '',
        voyageLeg: '',
        pol: '',
        pod: '',
        currentPage: 1,
        pageSize: 10,
        dataTime: []
      };
    },
    handleSelectionChange: function handleSelectionChange(selections, row) {
      if (selections.length > 1) {
        var del_row = selections.shift();
        this.$refs.multipleTable.toggleRowSelection(del_row, false);
        this.multipleSelection = selections;
      } else {
        this.multipleSelection = selections;
      }
    },
    handleSubimt: function handleSubimt() {
      console.log('this.multipleSelection', this.multipleSelection);
      if (this.multipleSelection) {
        this.$emit('selectionLaneChange', this.multipleSelection[0]);
      } else {
        this.$message({
          message: this.$t('userCenter.billConsigneeApplication.isSelectData'),
          type: 'warning'
        });
      }
    },
    closeDialog: function closeDialog() {
      this.$parent.sailScheduleLaneDialogVisible = false;
    },
    handleClear: function handleClear() {
      this.filterForm = {
        vesselCode: '',
        serviceLineCode: '',
        vesselNameCn: '',
        voyageNo: '',
        voyageLeg: '',
        pol: '',
        pod: '',
        currentPage: 1,
        pageSize: 100,
        dataTime: []
      };
    },
    closed: function closed() {
      this.handleClear();
    },
    handleSearch: function handleSearch() {
      var _this = this;
      this.$refs['filterForm'].validate(function (valid) {
        if (valid) {
          if ((0, _validate.validateNull)(_this.filterForm.dataTime) && (!_this.filterForm.voyageLeg || !_this.filterForm.voyageNo || !_this.filterForm.vesselName && !_this.filterForm.vesselCode)) {
            _this.$message.warning(_this.$t('home.pleaseEnterKeyWord'));
            return;
          }
          _this.tableData = [];
          _this.loading = (0, _utils.load)();
          var data = Object.assign({}, _this.filterForm);
          if (!(0, _validate.validateNull)(_this.filterForm.dataTime)) {
            data.etdFrom = data.dataTime[0];
            data.etdTo = data.dataTime[1];
          }
          delete data.dataTime;
          (0, _booking.queryListVoyagePlan)(data).then(function (res) {
            _this.tableData = res.data.records;
            _this.total = res.data.totalRecord;
          }).finally(function () {
            _this.loading.close();
          });
        }
      });
    }
  }
};